// Facebook Standard Events (from Meta documentation)
export type FacebookStandardEvent =
    | "CustomizeProduct"
    // | "CompleteRegistration"
    | "StartTrial"
    | "Purchase"
    | "PageView";

// Internal event names mapped to Facebook standard events
export type InternalEventName = "accountAdded" | "userCreated" | "subscriptionComplete";

// Standard Facebook event parameters (following Meta documentation)
export interface FacebookEventParams {
    // Standard e-commerce parameters
    currency?: string;
    value?: number;
    content_name?: string;
    content_type?: string;
    content_ids?: string[];
    content_category?: string;

    // Standard event-specific parameters
    predicted_ltv?: number;
    status?: string;

    // Advanced matching parameters (for server-side events)
    external_id?: string;
    client_user_agent?: string;
    client_ip_address?: string;
    event_id?: string;
    fbp?: string;
    fbc?: string;

    // Custom properties (for additional context)
    source?: string;
    [key: string]: any;
}

// Client-side event parameters (subset of FacebookEventParams)
export interface ClientEventParams
    extends Omit<FacebookEventParams, "external_id" | "client_user_agent" | "client_ip_address"> {}

// Server-side event parameters (subset of FacebookEventParams)
export interface ServerEventParams extends FacebookEventParams {}

// Event mapping structure
export interface FacebookEventMapping {
    facebookEventName: FacebookStandardEvent;
    eventURL: string;
    defaultParams: FacebookEventParams;
}

// Centralized event mapping - Internal events to Facebook standard events
export const FACEBOOK_EVENT_MAP: Record<InternalEventName, FacebookEventMapping> = {
    accountAdded: {
        facebookEventName: "CustomizeProduct",
        eventURL: "/admin/accounts",
        defaultParams: {
            content_name: "Account Configuration",
            content_type: "account_integration",
            value: 0,
            currency: "USD"
        }
    },
    userCreated: {
        //     facebookEventName: "CompleteRegistration",
        facebookEventName: "StartTrial",
        eventURL: "/register",
        defaultParams: {
            content_name: "User Registration",
            value: 0,
            currency: "USD",
            status: "completed"
        }
    },
    subscriptionComplete: {
        facebookEventName: "Purchase",
        eventURL: "/billing/success",
        defaultParams: {
            content_name: "Subscription Purchase",
            content_type: "subscription",
            value: 1,
            currency: "USD"
        }
    }
};

export function eventIdUserCreated(userId: string): string {
    return `user_${userId}`;
}

export function eventIdSubscriptionComplete(userId: string, subscriptionDate: string): string {
    return `subscription_${userId}_${subscriptionDate}`;
}

export function eventIdAccountAdded(userId: string, accountId: string): string {
    return `account_${userId}_${accountId}`;
}
